/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updateOptionProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import AnswerEmoji from 'material/embeds/content/shared/answer/emoji/emoji';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : EMOJI : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId, optionId }) => ({
    currentAnswer: embedsState.embedManagementState.contentStatus.contents[contentId].questionBased.options[optionId]
});
const mapDispatchToProps = dispatch => ({
    updateOptionProperty: (contentId, optionId, propertyName, value) => dispatch(updateOptionProperty(contentId, optionId, propertyName, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnswerEmoji);
